import * as api from '../api/index.js';      //import the separete file that contains axios functions

//fetching single post based on the id , action creator with thunk
export const getPost = (id) => async (dispatch) => {
  try {
    dispatch({ type: 'START_LOADING'});
    const { data } = await api.fetchPost(id);    
    dispatch({ type: 'FETCH_POST', payload: data }); 
    dispatch({ type: 'END_LOADING'});  
  } catch (error) {
    console.log(error);
  }
};   

//fetching all posts in a page , action creator with thunk
export const getPosts = (page) => async (dispatch) => {
  try {
    dispatch({ type: 'START_LOADING'});
    const { data } = await api.fetchPosts(page);    
    dispatch({ type: 'FETCH_ALL', payload: data }); 
    dispatch({ type: 'END_LOADING'});  
  } catch (error) {
    console.log(error);
  }
};


//fetching searched-posts , action creator with thunk
export const getPostsBySearch = (searchQuery) => async (dispatch) => {
  try {
    dispatch({ type: 'START_LOADING'});
    const { data: {data} } = await api.fetchPostsBySearch(searchQuery);    
    dispatch({ type: 'SEARCH', payload: data });
    dispatch({ type: 'END_LOADING'});    
  } catch (error) {
    console.log(error);
  }
};    

//create new post , action creator with thunk
export const createPost = (post)=> async (dispatch)=>{
    try {
        dispatch({ type: 'START_LOADING'});
        const {data}  = await api.createPost(post) ;        
        dispatch({ type : 'CREATE', payload :data  }) ;        
      }catch(error){
        console.log(error);
    }       
};

//update post , action creator with thunk
export const updatePost = (id,post)=> async (dispatch)=>{
  try {
      const {data}  = await api.updatePost(id,post) ;
      dispatch({ type : 'UPDATE', payload :data  }) ;
  }catch(error){
      console.log(error);
  }       
};

//delete post , action creator with thunk
export const deletePost = (id)=> async (dispatch)=>{
  try {
      await api.deletePost(id) ;
      dispatch({ type : 'DELETE' , payload: id}) ;
  }catch(error){
      console.log(error);
  }       
};

//like count of post , action creator with thunk
export const likePost = (id)=> async (dispatch)=>{
  try {
      const {data}  = await api.likePost(id) ;
      dispatch({ type : 'LIKE', payload :data  }) ;
  }catch(error){
      console.log(error);
  }       
};

//comment on a post , action creator with thunk
export const commentPost = (userComment,id)=> async (dispatch)=>{
  try {
    const {data}  = await api.commentPost(userComment,id) ;    
    dispatch({ type : 'COMMENT', payload :data }) ;
    return data.comments ;
  }catch(error){
      console.log(error);
  }       
};